import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SubHeaderComponent } from './sub-header/sub-header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { ModalCartComponent } from './modal/modal-cart/modal-cart.component';
import { Footer2Component } from './footer2/footer2.component';
import { LoaderComponent } from './loader/loader.component';
import { ImgFallbackDirective } from './img-fallback.directive';

@NgModule({
  declarations: [
    HeaderComponent,
    SubHeaderComponent,
    FooterComponent,
    ModalCartComponent,
    Footer2Component,
    LoaderComponent,
    ImgFallbackDirective,
  ],
  imports: [CommonModule, RouterModule, FormsModule],
  exports: [
    HeaderComponent,
    SubHeaderComponent,
    FooterComponent,
    ModalCartComponent,
    Footer2Component,
    LoaderComponent,
    ImgFallbackDirective,
    FormsModule,
  ],
})
export class ComponentsModule {}
